import React, { FunctionComponent, Component, useEffect, useState } from 'react';
import DashLayout from '../functionalComponents/DashboardLayout/DevDashboardLayout';
import DashRouters from '../../configs/routers/dev-dashboard-routers.json';
import { Row, Col, Alert, Card, Button, Form, Table, Modal  } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faExternalLinkSquareAlt, faPencilAlt, faSearch, faBars } from '@fortawesome/free-solid-svg-icons';
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
import AddTeamModal from '../Modals/addTeamModal';
import { ReactSortable } from 'react-sortablejs';
import SessionService from '../../services/SessionsService';
import AddOrganizationModal from '../Modals/addOrganizationModal';
import EditOrganizationModal from '../Modals/editOrganizationModal';


type IncomeProps = {
};


const DevOrganizations:FunctionComponent<IncomeProps> = ({ }) => {
  const history = useHistory();
  const [projects, setProjects] = useState([]);
  const [developers, setDevelopers] = useState([]);
  const [newdevelopers, setNewDevelopers] = useState([]);
  const [editing, setEdition] = useState(false);

  const [categories, setCategories] = useState([])

  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [filtro, setFilter] = useState('');

  const [listaAdd, setListaAA] = useState([]);
  const [activeTeam, setActiveTeam] = useState('');

  const [selected_org, setSelectedOrg] = useState(0);
  const [selected_org_name, setSelectedOrgName] = useState('');
  const [selected_org_description, setSelectedOrgDescription] = useState('');



  const changeFilter = (e) => {
    const newFilter = e.target.value;
    setFilter(newFilter);
  }



  const getDevelopers = async (team_id,team_name) => {
    try {
      setDevelopers([]);
      //setLoadingTable(true);
      const developersresult = (await ObexRequestHandler.get(`/team_devs?organization=${SessionService.ORGANIZATION}&team=${team_id}`, {}, true )).data || [];

      setDevelopers(developersresult);
      setNewDevelopers(developersresult);

      developersresult.forEach(element => {
        console.log(element.id);
      });

      setActiveTeam(team_name);

    } catch (error) {
      console.error('ERROR FETCHING PROJECTS ', error);


    }

  }



  const handleModal = () => {
    getProjects('');
    setShowModal(!showModal);
  };

  const handleModal2 = () => {
    getProjects('');
    setShowModal2(!showModal2);
  };

  const isTheCategory = (category, id) => {
    return category.id === id;
  }


  const handleSwitch = async (e, category, id) => {
    const index = newdevelopers.findIndex((category) => isTheCategory(category, id));
    var oo = new Array();
    newdevelopers.forEach((x)=>{oo.push(x)});

    //const newCategories = [...developers];
    oo[index].checked = !oo[index].checked;
    setNewDevelopers(oo);

    if (oo[index].checked == false){
      var resuu = (await ObexRequestHandler.get(`/remove_developer_team?organization=${oo[index].org_id}&dev_team=${activeTeam}&email=${oo[index].email}&dev_id=${oo[index].dev_id}`, {}, true )).data || [];
      console.log(resuu);
    } else {
      var resuu = (await ObexRequestHandler.get(`/add_developer_team?organization=${oo[index].org_id}&dev_team=${activeTeam}&email=${oo[index].email}`, {}, true )).data || [];
    }
  }

  const safeAndHideModal = async () => {
    const newCats = [];
    for (let id = 0; id < newdevelopers.length; id++) {
      const { email, checked } = newdevelopers[id];
      const cat = {
        id,
        email,
        checked
      }
      newCats.push(cat);
    }
    const payload = { order: newCats };

    
    const allDisabled = (newCats.filter(c => c.checked)).length < 1;
    if (!allDisabled) {
      //ObexRequestHandler.post('/custom_categories', payload);
    //onEditOrder(); // TODO mejorar esto para que use los movementStats ya almacenados que no tenga que pedirlos de nuevo
    

  
  }
  getProjects('');

    setEdition(false);
  }

  const categoriesList = (
    <Form>
      <ReactSortable tag="div" list={newdevelopers} setList={setNewDevelopers}>
          {newdevelopers.map(c => (
            c.validated ?
            <Row key={c.id} className="my-1">
              <Col>
                <Card className="product-detail-card obex-card api-product-card">
                  <Card.Body className="py-3 px-4">
                    <Row>
                      <Col className="pl-2">
                        <FontAwesomeIcon icon={faBars} className="button-sort mr-2" size="1x"/>
                        <span className="title-product">{c.email}</span>
                      </Col>

                      
                      <Col md="2" className="text-right">
                        <Form.Check 
                          checked={c.checked}
                          type="switch"
                          size={5}
                          id={`${c.id}`}
                          label=''
                          onChange={(e) => handleSwitch(e, c, c.id)}
                          className="obex-switch"
                        />
                        
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row> : <></>
          ))}
     </ReactSortable>
    </Form>
  )

  const modal = (
    <Modal dialogClassName="addons-dialog obex-dialog"
      show={editing} 
      onHide={safeAndHideModal}
      animation={false}
      scrollable>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="text-center mx-auto">
          <Row>
            <Col className="addons-title">
              <span>Developers</span>
            </Col>
          </Row>
        </Modal.Title>
      </Modal.Header>
      <div className="border-top border-black my-2 mx-3"></div>
      <Modal.Body className="pt-0">
        <Row className="px-3">
          <Col>
            {categoriesList}
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )

  

  const getProjects = async (filtro) => {
    try {
      setProjects([]);
      //setLoadingTable(true);
      const projects = (await ObexRequestHandler.get(`/my_organizations?dev_id=${SessionService.DEV_ID}`, {}, true )).data || [];

      if (filtro=='') setProjects(projects);
      else {

        var filter_projects = [];
        projects.forEach(element => {

          if (element.name.includes(filtro)) filter_projects.push(element);

          
        });

        setProjects(filter_projects);
      }

    } catch (error) {
      console.error('ERROR FETCHING PROJECTS ', error);


    }

  }


  useEffect(() => {
    getProjects('');
   // getDevelopers();
  }, []);


  return(
    <DashLayout sider={DashRouters} active={'organizations'} sublinks={[]}>
      <Row>
        <Col md="9" className="mx-auto" >
       <Row style={{marginTop:'20px'}}>
        <Col md={9} style={{marginLeft : '-20px'}}><h1>View your Organizations</h1></Col>
        <Col md={3} style={{paddingLeft : '-0px'}}>
         {/*     <Button disabled={null} className="btn-add obex-btn btn-add-green btn-block px-4" onClick={() => {setShowModal(true)}}>Create Organization</Button> */}
        </Col>
        
       </Row>
       <Form.Row >
        <Col md="9" style={{marginLeft : '-20px'}}>
          <Form.Control required type="text" value={filtro} placeholder="Search by Organization name" onChange={changeFilter} />
        </Col>
      
            <Col md={3}>
              <Button disabled={null} className="btn-add obex-btn btn-add-green btn-block px-4" onClick={() => {getProjects(filtro)}}><FontAwesomeIcon icon={faSearch} size="1x" className="mr-1"/></Button>
            </Col>
        </Form.Row>



       <Row style = {{marginTop:'20px'}}>
        <Col style={{marginLeft : '-20px'}}>
        <Table responsive className="obex-projects-table">
          <thead style={{fontFamily: 'Regular Intro Bold'}}>
            <tr>
              <th>Name</th>
              <th>Description</th>
              <th># Of Developers</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {projects.map(project =>  (
              <tr>
                <td>{project.name}</td>
                <td>{project.description}</td>
                <td>{project.developers}</td>
                <td className="text-right">
              {/*    <a className="edit-link"  onClick={async () => { */}
              {/*        //getDevelopers(project.id, project.name);
                      //setEdition(true);
                 //     setSelectedOrg(project.id);
                 //     setSelectedOrgName(project.name);
                 //     setSelectedOrgDescription(project.description)
                 //     handleModal2();
                 //   }
            //    }><FontAwesomeIcon icon={faPencilAlt} size="1x" className="mr-1"/></a> */}
                  </td>
              </tr>
            ))}
          </tbody>
          </Table>
        </Col>
      </Row>
      {showModal && <AddOrganizationModal show={showModal} organization={SessionService.ORGANIZATION} handleClose={handleModal}/>}
      {showModal2 && <EditOrganizationModal show={showModal2} organization={selected_org} organization_name={selected_org_name} organization_description={selected_org_description} handleClose={handleModal2}/>}
       {modal}
       </Col>
      </Row>
    </DashLayout>
  )
}

export default DevOrganizations;


